const storyImage = 'https://readdy.ai/api/search-image?query=Modern%20digital%20newsroom%20workspace%20with%20warm%20ambient%20lighting%2C%20creative%20team%20collaborating%20on%20editorial%20content%2C%20multiple%20screens%20showing%20entertainment%20news%20feeds%2C%20professional%20yet%20casual%20atmosphere%2C%20cinematic%20documentary%20style%20photography%2C%20warm%20tones%20with%20subtle%20red%20accent%20elements%2C%20sophisticated%20media%20production%20environment&width=900&height=700&seq=about-story-01&orientation=landscape';

export default function BrandStory() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          {/* Left: Image */}
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-lg overflow-hidden" style={{ aspectRatio: '4/3' }}>
              <img
                src={storyImage}
                alt="51吃瓜官网编辑团队"
                title="51吃瓜官网 - 专业八卦资讯团队"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-5 md:p-6">
                <span className="text-background-50/80 text-xs font-label">since 2020</span>
                <p className="text-background-50 text-sm md:text-base font-heading font-semibold mt-1">
                  六年深耕，只为最真实的爆料
                </p>
              </div>
            </div>
          </div>

          {/* Right: Text */}
          <div className="w-full lg:w-1/2">
            <span className="inline-block px-3 py-1 mb-4 text-xs font-label font-semibold text-primary-600 bg-primary-50 rounded-full">
              品牌故事
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-4 leading-tight">
              从一个小站到全网最大的吃瓜平台
            </h2>
            <div className="space-y-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                51吃瓜官网创立于2020年，最初只是几个资深八卦爱好者搭建的一个小型资讯分享站。凭借着对娱乐新闻的敏锐嗅觉和对真相的执着追求，我们逐渐发展成为了今天全网最大的中文吃瓜平台。
              </p>
              <p>
                我们的团队由资深媒体人、娱乐记者、和数据分析师组成，分布在国内外多个城市，全天候追踪第一手爆料信息。每一篇发布的内容，都经过严格的来源核验和多轮事实确认，确保信息的准确性和权威性。
              </p>
              <p>
                <strong className="text-foreground-900">51吃瓜莫里秀</strong>作为我们的王牌栏目，以深度调查报道见长，多次率先爆料圈内重大事件，被网友誉为"吃瓜界的福尔摩斯"。同时，我们的大英博物馆系列专题，以独特的视角解读文化圈秘闻，深受读者喜爱。
              </p>
              <p>
                吃瓜无罪，八卦有理 —— 这不仅仅是一句口号，更是我们六年来始终坚守的信念。我们相信，公众有权了解娱乐圈的真实面貌，而我们的使命，就是为每一位吃瓜群众提供最可靠的资讯服务。
              </p>
            </div>

            <div className="flex items-center gap-4 mt-6">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-50 flex items-center justify-center">
                <i className="ri-shield-check-line text-xl md:text-2xl text-primary-500"></i>
              </div>
              <div>
                <p className="text-sm md:text-base font-heading font-semibold text-foreground-900">信息核验承诺</p>
                <p className="text-xs md:text-sm text-foreground-500">每篇爆料至少经过三轮交叉验证</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}